import { render } from "./RunningBcoCard.vue?vue&type=template&id=65777af2&scoped=true"
import script from "./RunningBcoCard.vue?vue&type=script&lang=js"
export * from "./RunningBcoCard.vue?vue&type=script&lang=js"

import "./RunningBcoCard.vue?vue&type=style&index=0&id=65777af2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65777af2"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpinner,QBtn,QPagination});
